import moment from "jalali-moment";
import React from "react";
import {
  DATE_FORMAT_EMPTY_STATE,
  DATE_FORMAT_IN_NUMBERS,
  DAY_OF_WEEK,
  DAY_OF_WEEK_EMPTY_STATE
} from "../constants/dateTime";
export const formatDateInLetters = (date, format) => {
  try {
    return date !== "--/--/----"
      ? moment(date)
          .locale("fa")
          .format(format ? format : "DD MMMM YYYY")
      : "--/--/----";
  } catch (e) {
    return "--/--/----";
  }
};

export const formatDateInNumbers = date => {
  try {
    return date
      ? moment(date)
          .locale("fa")
          .format(DATE_FORMAT_IN_NUMBERS)
      : DATE_FORMAT_EMPTY_STATE;
  } catch (e) {
    return DATE_FORMAT_EMPTY_STATE;
  }
};

export const formatDateTime = (date, time) => {
  const normalTime = time ? " - " + moment(time, "HH:mm").format("HH:mm") : "";
  return (
    <span className="date-time">
      {date}
      {normalTime}
    </span>
  );
};

export const formatDateTime1 = dateTime => {
  const _dateTime = dateTime.split(" ");
  const date = _dateTime[0];
  const time = _dateTime[1];
  const normalTime = time ? " - " + moment(time, "HH:mm").format("HH:mm") : "";
  return (
    <span className="date-time">
      {date}
      {normalTime}
    </span>
  );
};

export const getMonth = date => {
  return date !== "--/--/----"
    ? moment(date)
        .locale("fa")
        .format("MMMM")
    : moment()
        .locale("fa")
        .format("MMMM");
};

export const monthsArray = [
  "فروردين",
  "ارديبهشت",
  "خرداد",
  "تير",
  "مرداد",
  "شهريور",
  "مهر",
  "آبان",
  "آذر",
  "دی",
  "بهمن",
  "اسفند"
];
export const getMonthName = monthNumber => {
  return monthsArray[monthNumber - 1];
};

export const getMonthNumber = monthName => {
  return monthsArray.indexOf(monthName) + 1;
};

export const getYear = date => {
  return date !== "--/--/----"
    ? moment(date)
        .locale("fa")
        .format("YYYY")
    : moment()
        .locale("fa")
        .format("YYYY");
};

export const getDayOfWeek = date => {
  try {
    return moment(date)
      .locale("fa")
      .format(DAY_OF_WEEK);
  } catch (e) {
    return DAY_OF_WEEK_EMPTY_STATE;
  }
};
